import { render, staticRenderFns } from "./correction-or-interpretation-of-judgment-request.vue?vue&type=template&id=17f2a27e&scoped=true&"
import script from "./correction-or-interpretation-of-judgment-request.vue?vue&type=script&lang=js&"
export * from "./correction-or-interpretation-of-judgment-request.vue?vue&type=script&lang=js&"
import style0 from "./correction-or-interpretation-of-judgment-request.vue?vue&type=style&index=0&id=17f2a27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2a27e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
